// Amenity Icons
export const amenityIcons = {
    pool: '/images/amenities/pool-icon.svg',
    gym: '/images/amenities/gym-icon.svg',
    garden: '/images/amenities/garden-icon.svg',
    security: '/images/amenities/security-icon.svg',
};

// Project Gallery
export const projectImages = {
    exterior: '/images/gallery/exterior-view.jpg',
    lobby: '/images/gallery/lobby.jpg',
    clubhouse: '/images/gallery/clubhouse.jpg',
    gym: '/images/gallery/gym.jpg',
    pool: '/images/gallery/pool.jpg',
    garden: '/images/gallery/garden.jpg',
};

// Decorative Elements
export const decorativeElements = {
    leafPattern: '/images/decorative/leaf-pattern.svg',
    wavyLine: '/images/decorative/wavy-line.svg',
    dots: '/images/decorative/dots-pattern.svg',
    abstractShape: '/images/decorative/abstract-shape.svg',
};

// Background Patterns
export const backgroundPatterns = {
    lightPattern: '/images/patterns/light-pattern.svg',
    darkPattern: '/images/patterns/dark-pattern.svg',
    goldPattern: '/images/patterns/gold-pattern.svg',
};

// 3D Renders
export const renders = {
    livingRoom: '/images/renders/living-room.jpg',
    bedroom: '/images/renders/bedroom.jpg',
    kitchen: '/images/renders/kitchen.jpg',
    bathroom: '/images/renders/bathroom.jpg',
};

// Location Graphics
export const locationGraphics = {
    map: '/images/location/area-map.svg',
    landmarks: '/images/location/landmarks.svg',
    connectivity: '/images/location/connectivity.svg',
}; 